/*@flow*/
import getShareUrl from './getShareUrl';
import type { UrlProps } from './types';

export default (props: UrlProps): string => {
  let url = getShareUrl(props);
  return `<div class='h_wrapper' style='overscroll-behavior: contain;width:100%;height:100%;margin:0 auto;background:#CCC; min-height: 800px;'><div class='h_iframe' style='position:relative;width:100%;height:100%;margin:0 auto;background:#CCC; min-height: 800px;'><iframe frameborder='0' src='${url}' style='position:absolute;top:0;left:0;width:100%; height:100%;'></iframe></div></div><style type="text/css" media="screen">html,body{width:100%;height: 100%;}</style>`;
};
